<template>
  <XField
    :errors="validationErrors(parameters.type)"
    :errorStyle="formFieldsErrorStyle">
    <XSelect
      color="secondary"
      placeholder=" "
      :label="$t('common.formFields.' + parameters.type)"
      :labelStyle="labelStyle"
      :inputStyle="validationHasErrors(parameters.type) ? inputCustomStyles: {}"
      :options="formattedCountries"
      :data-vv-name="parameters.type"
      :invalid="validationHasErrors(parameters.type)"
      :optional="isOptional"
      v-model="fieldValue"
      v-validate="{ required: parameters.required }"
      @blur="validate" />
  </XField>
</template>

<script>
import _ from 'lodash'
import InputMixin from './InputMixin'
import { countries } from '@common/utils'

export default {
  mixins: [InputMixin],

  methods: {
    validate () {
      this.$validator.validate(this.parameters.type)
    }
  },

  computed: {
    translations () {
      let translations = require('@common/lang/countries').default[this.$i18n.locale]

      return Object.values(translations)
    },

    formattedCountries () {
      return _.zipObject(countries, this.translations)
    }
  }
}
</script>
